import {buildStateEvent, GenericStateEvent} from '../../common-redux'
import {PriorityLevelProblem} from '../priority'

export interface UrgencyProblemStateEvent<T> extends GenericStateEvent<T> {}

export const GetAllUrgencyPriortySuccessEvent = {
    type: 'GetAllUrgencyPriortySuccessEvent',
    build: (payload: PriorityLevelProblem[]) => buildStateEvent(GetAllUrgencyPriortySuccessEvent.type, payload)
}
